<section class="text-gray-600 body-font">
  <div class="container px-5 pb-20 mx-auto">
    <h1 class="text-3xl font-medium title-font text-gray-900 leading-tight mb-10">Impressum</h1>
    <h2 class="font-medium leading-tight text-xl">ACA Brazilian Jiu-Jitsu</h2>
    <div>Ando Cardoso</div>
    <div>Wallisellenstrasse 301a, 8050 Zürich</div>
    <div>+41 79 331 8001</div>
  </div>
</section>
